var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("button " + _vm.className),attrs:{"disabled":_vm.disabled,"type":_vm.type},on:{"click":_vm.onclick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }